import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private navigationSource = new BehaviorSubject<string>(null);
  navigation$ = this.navigationSource.asObservable();

  setNavigationEvent(value: string) {
    this.navigationSource.next(value);
  }
  clearNavigationEvent() {
    this.navigationSource.next(null);
  }
}
